import { useContext } from 'react';
import { DocumentPermissionsContext } from "../context/document-permissions.js";
export const useDocumentPermissions = () => useContext(DocumentPermissionsContext);
//# sourceMappingURL=use-document-permissions.js.map